module.exports = __webpack_public_path__ + "img/index-5.dfd6a731.png";